// extracted by mini-css-extract-plugin
export default {"services":"ServicesSection_services__pRpA0","serviceCard":"ServicesSection_serviceCard__TmxFR"};